import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import "./FrameworkComponent.css";
import ProviderStore from '../../stores/ProvidersStore';
import GraphQLHelper from '../../helpers/common/GraphQLHelper';
import LoaderComponent from '../common/LoaderComponent';
import Tooltip from "@material-ui/core/Tooltip";
import DropdownComponent from '../common/inputs/DropdownComponent';
import TextInputComponent from '../common/inputs/TextInputComponent';
import Select from "react-select";
import CreatableSelect from 'react-select/creatable';
import { InputWidthTypes } from '../../helpers/common/StyleHelper';
import { TimestampType } from '../../models/ProviderDetails/ProviderDetailsExpansion';
import ClientRegistrationErrorModel from '../../models/ClientRegistration/ClientRegistrationErrorModel';
import ClientRegistrationModel from '../../models/ClientRegistration/ClientRegistrationModel';
import SSOConfigModel, { OUTBOUND_SSO_URL_PLACEHOLDER, AP_USERID_NAME, AP_USERNAME_NAME, AP_EMAIL_NAME, AP_FIRSTNAME_NAME, AP_LASTNAME_NAME, AP_MIDDLENAME_NAME, AP_USERDIVISION_NAME, AP_USERLOCATION_NAME, AP_LNGUAGE_NAME, AP_PHONEHOME_NAME, AP_WORKPHONE_NAME, AP_MANAGERID_NAME } from '../../models/SSOConfig/SSOConfigModel';
import LabelComponent from '../common/inputs/LabelComponent';
import CodeHelpers from '../../helpers/common/CodeHelpers';
import { v4 } from 'uuid';
import { ACS_URL_CY_DATA, ADDITIONAL_SETTINGS_DROPDOWN_CY_DATA, ADDITIONAL_SETTING_ADD_CY_DATA, ADDITIONAL_SETTING_DELETE_CY_DATA, ADDITIONAL_SETTING_KEY_CY_DATA, ADDITIONAL_SETTING_POSITION_CY_DATA, ADDITIONAL_SETTING_ROW_CY_DATA, ADDITIONAL_SETTING_TYPE_CY_DATA, ADDITIONAL_SETTING_VALUE_CY_DATA, ADVANCED_PROPERTIES_DROPDOWN_CY_DATA, AUDIENCE_CY_DATA, AUTHENTICATION_PARAMETERS_MAPPING_DROPDOWN_CY_DATA, AUTHENTICATION_REQUEST_DESTINATION_CY_DATA, AUTHENTICATION_REQUEST_ISSUER_CY_DATA, EMAIL_ADRESS_APM_CY_DATA, ENABLE_SSO_CY_DATA, FIRST_NAME_APM_CY_DATA, INCLUDE_ISSUER_IN_RESPONSE_CY_DATA, ISSUER_CY_DATA, LANGUAGE_APM_CY_DATA, LAST_NAME_APM_CY_DATA, MANAGER_ID_APM_CY_DATA, MIDDLE_NAME_APM_CY_DATA, OUTBOUND_SSO_URL_CY_DATA, PHONE_HOME_APM_CY_DATA, QUERYSTRING_PARAMETERS_DROPDOWN_CY_DATA, QUERYSTRING_PARAMETER_ADD_CY_DATA, QUERYSTRING_PARAMETER_DELETE_CY_DATA, QUERYSTRING_PARAMETER_NAME_CY_DATA, QUERYSTRING_PARAMETER_ROW_CY_DATA, QUERYSTRING_PARAMETER_SAML_ATTRIBUTE_CY_DATA, SIGNATURE_WITHIN_ASSERTION_CY_DATA, SP_INITIATED_DROPDOWN_CY_DATA, SP_INITIATED_ENABLE_CY_DATA, SSO_ID_OU_ID_CY_DATA, TIMESTAMP_FORMAT_CY_DATA, USERNAME_APM_CY_DATA, USER_DIVISION_APM_CY_DATA, USER_ID_APM_CY_DATA, USER_LOCATION_APM_CY_DATA, WORK_PHONE_APM_CY_DATA } from '../../cypressDataConstants/providerSsoConfigCyDataConstants';
import FrameworkHelpers from '../../helpers/framework/FrameworkHelpers';

const activityStates = ["active","disabled"]
const allowedScopes = ["progress:write","progress:read","content:launch","token:revoke","admin:clients:read","admin:clients:write"]
const clientAuths = ["client_secret_basic","client_secret_post"]
const tokenFormats = ["opaque","jwt"];
const capPolicies = ["deny", "evict_oldest"]

interface ClientRegistrationProps {
    providers?: ProviderStore,
    isScrolledToProblemElement: boolean,
    callSecretPopup: () => void
    callSuccessPopup: () => void
    callFailurePopup: () => void
    onScrolledToProblemElement: () => void
    resetErrors: () => void
}

interface ClientRegistrationState {
    ClientId:  string,
    ProviderId:  string ,
    Name:  string ,
    Status:  string | null,
    AllowedScopes:  [string] | null,
    TokenLifetimeSeconds:  number | null,
    MaxActiveTokens:  number | null,
    CapPolicy:  string | null,
    TokenFormat:  string | null,
    AllowedClientAuth:  [string] | null,
    AudienceAllowed:  [string] | null,
    JwksUri:  string | null
    isSubmitRequestPostingUpdate:boolean,
    isSubmitRequestPostingCreate:boolean,
    isSubmitRequestPostingRotate:boolean,
    clientRegistrationExists:boolean
}

@inject('providers')
@observer
export default class ClientRegistration extends Component<ClientRegistrationProps, ClientRegistrationState > {
    constructor(props: ClientRegistrationProps) {
        super(props);
        if(this.props.providers.CurrentProvider.Id != this?.props?.providers?.CurrentClientRegistrationDetails?.ClientId){
            this.props.providers.CurrentClientRegistrationDetails = {};
        }
        this.state = { 
            ClientId:this?.props?.providers?.CurrentClientRegistrationDetails?.ClientId ?? this.props.providers.CurrentProvider.Id,
            ProviderId:this?.props?.providers?.CurrentClientRegistrationDetails?.ProviderId ?? this.props.providers.CurrentProvider.Id,
            Name:this?.props?.providers?.CurrentClientRegistrationDetails?.Name ?? this.props.providers?.CurrentProvider?.Name,
            Status:this?.props?.providers?.CurrentClientRegistrationDetails?.Status ?? "active",
            AllowedScopes:this?.props?.providers?.CurrentClientRegistrationDetails?.AllowedScopes ?? ["progress:write"],
            TokenLifetimeSeconds:this?.props?.providers?.CurrentClientRegistrationDetails?.TokenLifetimeSeconds ?? 3600,
            MaxActiveTokens:this?.props?.providers?.CurrentClientRegistrationDetails?.MaxActiveTokens ?? 5,
            CapPolicy:this?.props?.providers?.CurrentClientRegistrationDetails?.CapPolicy ?? "evict_oldest",
            TokenFormat:this?.props?.providers?.CurrentClientRegistrationDetails?.TokenFormat ?? "opaque",
            AllowedClientAuth:this?.props?.providers?.CurrentClientRegistrationDetails?.AllowedClientAuth ?? ["client_secret_basic"],
            AudienceAllowed:this?.props?.providers?.CurrentClientRegistrationDetails?.AudienceAllowed ?? [],
            JwksUri:this?.props?.providers?.CurrentClientRegistrationDetails?.JwksUri ?? "",
            isSubmitRequestPostingUpdate:false,
            isSubmitRequestPostingCreate:false,
            isSubmitRequestPostingRotate:false,
            clientRegistrationExists: this?.props?.providers?.CurrentClientRegistrationDetails?.ClientId
        }

    }

    componentDidUpdate = () => {
        FrameworkHelpers.goToProblemElement(this.props.isScrolledToProblemElement,this.props.onScrolledToProblemElement);
        // this.clearErrorStyling();
    }

    componentDidMount = () => {
        FrameworkHelpers.goToProblemElement(this.props.isScrolledToProblemElement,this.props.onScrolledToProblemElement);
    }
    onStatusChanged = (value: string) => {
        this.props.providers!.CurrentClientRegistrationDetails!.Status = value;
        this.setState({ Status: value });
    }
    onNameChanged = (value: string) => {
        this.props.providers!.CurrentClientRegistrationDetails!.Name = value;
        this.setState({ Name: value });
    }

    onAllowedScopesChanged = (value: [string]) => {
        var data = value.map((x) => {
            return x.value;
        });
        this.props.providers!.CurrentClientRegistrationDetails!.AllowedScopes = data;
        this.setState({ AllowedScopes: data });
    }
    onAudienceAllowedChanged = (value: [any]) => {
        var data = value.map((x) => {
            return x.value;
        });
        this.props.providers!.CurrentClientRegistrationDetails!.AudienceAllowed = data;
        this.setState({ AudienceAllowed: data });
    }
    onAllowedClientAuthChanged = (value: [string]) => {
         var data = value.map((x) => {
            return x.value;
        });
        this.props.providers!.CurrentClientRegistrationDetails!.AllowedClientAuth = data;
        this.setState({ AllowedClientAuth: data });
    }
    onTokenLifeSecondsChanged = (value: any) => {
        this.props.providers!.CurrentClientRegistrationDetails!.TokenLifetimeSeconds = value;
        this.setState({ TokenLifetimeSeconds: value });
    }
    onMaxActiveTokenChanged = (value: any) => {
        this.props.providers!.CurrentClientRegistrationDetails!.MaxActiveTokens = value;
        this.setState({ MaxActiveTokens: value });
    }
    onCapPolicyChanged  = (value: string) => {
        this.props.providers!.CurrentClientRegistrationDetails!.CapPolicy = value;
        this.setState({ CapPolicy: value });
    }
    onTokenFormatChanged  = (value: string) => {
        this.props.providers!.CurrentClientRegistrationDetails!.TokenFormat = value;
        this.setState({ TokenFormat: value });
    }
    onJwksUriChanged  = (value: string) => {
        this.props.providers!.CurrentClientRegistrationDetails!.JwksUri = value;
        this.setState({ JwksUri: value });
    }
    onUpdateClick  = async() => {
        try{
            this.setState({ isSubmitRequestPostingUpdate: true });
            const { isSubmitRequestPostingUpdate, isSubmitRequestPostingCreate, isSubmitRequestPostingRotate,clientRegistrationExists, ...relevantStateItem } = this.state;
            await GraphQLHelper.UpdateProviderAuthClientDetails(relevantStateItem);
            this.props.callSuccessPopup();
        }
        catch(e) {
            console.log(e);
            this.props.providers!.CurrentClientRegistrationDetails!.ErrorMessage= JSON.stringify(e);
            this.props.callFailurePopup();
        }
        finally{
            this.setState({ isSubmitRequestPostingUpdate: false });
        }
    }

    onCreateClick  =  async() => {
        try{
            this.setState({ isSubmitRequestPostingCreate: true });
            const { isSubmitRequestPostingUpdate, isSubmitRequestPostingCreate, isSubmitRequestPostingRotate,clientRegistrationExists, ...relevantStateItem } = this.state;
            var data = await GraphQLHelper.CreateProviderAuthClientDetails(relevantStateItem);
            this.props.providers!.CurrentClientRegistrationDetails!.SecretString = data.Secret;
            this.props.callSecretPopup();
        }
        catch(e) {
            console.log(e);
            this.props.providers!.CurrentClientRegistrationDetails!.ErrorMessage= JSON.stringify(e);
            this.props.callFailurePopup();
        }
        finally{
            this.setState({ isSubmitRequestPostingCreate: false });
        }
    }

    onRotateClick  =  async() => {
        try{
            this.setState({ isSubmitRequestPostingRotate: true });
            const { isSubmitRequestPostingUpdate, isSubmitRequestPostingCreate, isSubmitRequestPostingRotate,clientRegistrationExists, ...relevantStateItem } = this.state;
            var data =await GraphQLHelper.RotateProviderAuthClientDetails(this.state.ClientId);
            this.props.providers!.CurrentClientRegistrationDetails!.SecretString = data.Secret;
            this.props.callSecretPopup();
        }
        catch(e) {
            console.log(e);
            this.props.providers!.CurrentClientRegistrationDetails!.ErrorMessage= JSON.stringify(e);
            this.props.callFailurePopup();
        }
        finally{
            this.setState({ isSubmitRequestPostingRotate: false });
        }
    }
    
    render() {
        return <div className = "csod-framework-tab-content">
            <div className = "csod-framework-layer erases-at-disabling">
                <div className = "csod-framework-header non-selectable">{"OAuth Client Details"}</div>
                <div className="csod-inputs-row-container two-columns-container">
                    <TextInputComponent title="Client ID" disabled={true} onValueChanged={() => {}} widthClass={InputWidthTypes.Middle} defaultValue=  {this.props.providers?.CurrentProvider?.Id}  maxlength={100}  />
                    <TextInputComponent title="Provider ID" disabled={true} onValueChanged={() => {}} widthClass={InputWidthTypes.Middle} defaultValue={this.props.providers?.CurrentProvider?.Id}  maxlength={100}  />
                </div>
                <div className="csod-inputs-row-container two-columns-container">
                    <TextInputComponent title="Name"  widthClass={InputWidthTypes.Middle} onValueChanged={this.onNameChanged} defaultValue={this.state?.Name} 
                      maxlength={500}  />
                    <DropdownComponent title="Status Type" placeholder="Choose Status" items={activityStates} widthClass={InputWidthTypes.Middle} defaultValue={this.state.Status} 
                     onValueChanged={this.onStatusChanged}/>
                </div>
               <div className="csod-inputs-row-container two-columns-container">
                    <div className='csod-inputs-column-container middle-width'>
                        <div className="csod-input-title-text non-selectable">Allowed Scopes </div>
                        <Select  myFontSize="20px" isMulti={true} options={allowedScopes.map(x=>({label: x,value:x}))} value={this.state.AllowedScopes.map(x=>({label: x,value:x}))} onChange={this.onAllowedScopesChanged} />
                    </div>
                    <TextInputComponent title="Token Life Seconds" placeholder="Number between 5 and 604800"  onValueChanged={this.onTokenLifeSecondsChanged}  type="number" maxNumber={604800} minNumber={5} widthClass={InputWidthTypes.Middle} defaultValue={this.state.TokenLifetimeSeconds}  maxlength={100}  />
                </div>
               <div className="csod-inputs-row-container two-columns-container">
                    <TextInputComponent title="Max Active Tokens" placeholder="Number between 1 and 10"  onValueChanged={this.onMaxActiveTokenChanged}  type="number" maxNumber={10} minNumber={1} widthClass={InputWidthTypes.Middle} defaultValue={this.state.MaxActiveTokens}  maxlength={100}  />
                    <DropdownComponent title="Cap Policy" items={capPolicies} widthClass={InputWidthTypes.Middle} defaultValue={this.state.CapPolicy} 
                    onValueChanged={this.onCapPolicyChanged}/>
                </div>
                 <div className="csod-inputs-row-container two-columns-container">
                     <DropdownComponent title="Token Format" items={tokenFormats} widthClass={InputWidthTypes.Middle} defaultValue={this.state.TokenFormat} 
                    onValueChanged={this.onTokenFormatChanged}/>
                    <div className='csod-inputs-column-container middle-width'>
                        <div className="csod-input-title-text non-selectable">Allowed Client Auth </div>
                        <Select  myFontSize="20px" isMulti={true} options={clientAuths.map(y=>({label: y,value:y}))}  value={this.state.AllowedClientAuth?.map(x=>({label: x,value:x}))} onChange={this.onAllowedClientAuthChanged} />
                    </div>
                </div>
                 <div className="csod-inputs-row-container two-columns-container">
                    <div className='csod-inputs-column-container middle-width'>
                        <div className="csod-input-title-text non-selectable">Audience Allowed </div>
                        <CreatableSelect  myFontSize="20px" isMulti={true} value={this.state.AudienceAllowed.map(y=>({label: y,value:y}))} onChange={this.onAudienceAllowedChanged} />
                    </div>
                    <TextInputComponent title="JWKS URI" widthClass={InputWidthTypes.Middle} defaultValue={this.state.JwksUri} onValueChanged={this.onJwksUriChanged}  />
                </div> 
            </div>
               <div className="csod-inputs-row-container">
                    <button type="submit" disabled={this.state.clientRegistrationExists}  className={`csod-button blue less-rounded-corners submitMenu ${this.state.clientRegistrationExists ? "disabled" : ""}`} onClick={this.onCreateClick} >{this.state.isSubmitRequestPostingCreate ? <LoaderComponent isLoading={true} /> : "Create"}</button>
                    <button type="submit" disabled={!this.state.clientRegistrationExists} className={`csod-button blue less-rounded-corners submitMenu ${!this.state.clientRegistrationExists ? "disabled" : ""}`}  onClick={this.onUpdateClick} >{this.state.isSubmitRequestPostingUpdate ? <LoaderComponent isLoading={true} /> : "Update"}</button>
                    <Tooltip title="By generating a new secret, all previously issued secrets will be immediately invalidated">
                        <button style={{width:'190px'}} type="submit" disabled={!this.state.clientRegistrationExists} className={`csod-button blue less-rounded-corners submitMenu ${!this.state.clientRegistrationExists ? "disabled" : ""}`}  onClick={this.onRotateClick} >{this.state.isSubmitRequestPostingRotate ? <LoaderComponent isLoading={true} /> : "Replace Secret"}</button>
                    </Tooltip>
               </div>
        </div>
    }
}